































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import { formatKWh } from "@/utils/LocalisationHelper";
import {
  ProgramChain,
  doesProgramChainIncludeActiveRun,
} from "@/data/models/ProgramChain";

import { ClientPanel, getClientPanelDisplayName } from "@/data/models/ClientPanel";

import {
  getMostRecentProgramChain,
  observeProgramChainsInTimeRanges,
} from "@/data/repository/ProgramChainRepository";
import { getPanel, observePanel } from "@/data/repository/PanelRepository";

import { formatDateShort, timestampToDate } from "@/utils/DateFormatter";
import { firestore } from "firebase/app";
import { areOnSameDay, isAfter } from "@/utils/DateHelper";

import {
  ClientPanelAssignment,
  doesAssignmentIncludeProgramChain,
  MeterReadingInfo,
  getClientPanelDisplayNameFromAssignment
} from "@/data/models/ClientPanelAssignment";
import { ProjectDetails } from "@/data/models/ProjectDetails";
import router from "@/router/router";

import { ProgramChainModule } from "@/store/modules/ProgramChainModule";

import IresDeviceOverviewItemComponent from "@/components/devices/IresDeviceOverviewItem.vue";
import IresDeviceStatusComponent from "@/components/devices/IresDeviceStatus.vue";
import DryingProgressGraphWrapperComponent from "@/components/panel/DryingProgressGraphWrapper.vue";
import { ButtonState } from "@/components/common/StateButton.vue";
import {
  getIresDeviceCategoryFromSerialNumber,
  IresDevice,
  IresDeviceCategory,
  isActiveProgramChainOfIresDevice,
  isIdle,
  isInStandBy,
  isInWarningOrError,
  isPoweredOff,
} from "@/data/models/IresDevice";
import { getComBox, observeComBox } from "@/data/repository/ComBoxRepository";
import { getClientPanel } from "@/data/repository/ClientPanelRepository";
import {
  COLOR_PROJECT_STEP_BUTTON_COMPLETE,
  COLOR_PROJECT_STEP_BUTTON_OVERDUE,
  COLOR_PROJECT_TILE_INCOMPLETE,
  COLOR_STANDARD_WHITE,
  COLOR_SURFACE_DARK,
} from "@/utils/colors";
import { themed, themedFill, themedFillTextColor } from "@/utils/Theme";
import { ProjectDetailsTab } from "@/data/models/ProjectDetailsTab";
import { getCategoryIdFromSerialNumber, getTemplateIdFromSerialNumber, getUpdatedCategoryAndTemplateIds } from "@/data/models/DeviceSettingsManager";
import { getTemplate } from "@/data/repository/GenericDeviceRepository";
import { defineCategoriesAndTemplatesClientAccess } from "@/permissions/ClientPermissions";
import { DeviceCategoriesAndTemplatesModule } from "@/store/modules/DeviceCategoriesAndTemplatesModule";
import { DeviceProjectAssignment } from "@/data/models/DeviceProjectAssignment";
import { 
  extractPowerConsumptionInput, 
  GenericDevicePowerConsumptionInput, 
  GenericDeviceProjectAssignment 
} from "@/data/models/GenericDeviceAssignment";
import { shouldHideSerialNumber } from "@/data/repository/ClientRepository";

@Component({
  components: {
    "ires-device-overview-item": IresDeviceOverviewItemComponent,
    "drying-progress": DryingProgressGraphWrapperComponent,
    "ires-device-status": IresDeviceStatusComponent,
  },
})
export default class DeviceProjectAssignmentItemComponent extends Vue {
  @Prop() isClientPanelAssignment!: boolean;
  @Prop() elevation!: number;
  @Prop() projectDetails!: ProjectDetails;
  @Prop() deviceProjectAssignment!: DeviceProjectAssignment;
  @Prop() lastDisplayedDate!: Date;
  @Prop() areDependantAssignmentsReleased!: boolean;
  @Prop({ default: true }) canEditAssignment!: boolean;
  @Prop({ default: true }) editEnabled!: boolean;
  @Prop({ default: false }) showCompactVersion!: boolean;
  @Prop({ default: ProjectDetailsTab.DEVICES })

  usedInTab!: ProjectDetailsTab;

  get isActiveAssignment() {
    return this.deviceProjectAssignment?.assignmentEndDate === null;
  }

  get isAllowedToDefineOwnDeviceCategoriesAndTemplates() {
    return defineCategoriesAndTemplatesClientAccess();
  }

  get isCountedViaExternalDevice() {
    if (this.isClientPanelAssignment) {
      return false;
    }
    const assignment = this.deviceProjectAssignment as GenericDeviceProjectAssignment;

    return assignment?.externalElectricityMeterInfo !== null;
  }

  get shouldHideSerialNumber() {
    return shouldHideSerialNumber();
  }

  get externalCountingDeviceText() {
    if (this.isClientPanelAssignment) {
      return "";
    }

    const assignment = this.deviceProjectAssignment as GenericDeviceProjectAssignment;

    // To remove template name from the device name.
    const deviceNameParts = assignment?.externalElectricityMeterInfo?.deviceName.split("- ");
    const deviceNameWithoutTemplateName = deviceNameParts 
      ? deviceNameParts[deviceNameParts.length - 1] 
      : assignment?.externalElectricityMeterInfo?.deviceName;

    const deviceName = 
      this.shouldExplicitlyPrependInventoryNumber && 
      this.clientPanel?.inventoryNumber && 
      this.clientPanel.inventoryNumber !== "" && 
      this.clientPanel.inventoryNumber !== deviceNameWithoutTemplateName
        ? this.clientPanel.inventoryNumber + " / " + deviceNameWithoutTemplateName
        : deviceNameWithoutTemplateName;

    if (deviceName && deviceName !== "") {
      if (this.shouldHideSerialNumber) {
        return this.$t("panelDetail.externalCountingMeter", [deviceName.split(" /")[0]]);
      }

      // If inventory number and serial number are same.
      const deviceNameInventoryNumberParts = deviceName.split(" / ");
      if (
        deviceNameInventoryNumberParts && 
        deviceNameInventoryNumberParts.length > 1 &&
        deviceNameInventoryNumberParts[0] === deviceNameInventoryNumberParts[deviceNameInventoryNumberParts.length - 1]
      ) {
        return this.$t("panelDetail.externalCountingMeter", [deviceName.split(" /")[0]]);
      }

      return this.$t("panelDetail.externalCountingMeter", [deviceName]);
    }
    
    return "";
  }

  get sharedDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.sharedDeviceCategoriesAndTemplates;
  }

  get localDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.localDeviceCategoriesAndTemplates;
  }

  get deviceSettingsJson() {
    return this.isAllowedToDefineOwnDeviceCategoriesAndTemplates
      ? this.localDeviceSettingsJson
      : this.sharedDeviceSettingsJson;
  }

  get meetsReleaseConditions() {
    return !this.isShowingOpenEndedAssignment || this.areDependantAssignmentsReleased;
  }

  get editButtonState() {
    if (!this.meetsReleaseConditions) {
      return ButtonState.GRAY_NOT_DISABLED;
    }

    return this.editEnabled
      ? ButtonState.RED
      : ButtonState.GRAY_NOT_DISABLED;
  }

  areDeviceDetailsLoaded = false;
  iresDevice: IresDevice | null = null;

  didLoadProgramChains = false;

  subscriptions: Array<() => void> = [];
  programChains: Array<ProgramChain> = [];

  showNoProgramChainIncludedInAssignmentWarning = false;
  showNoActiveProgramChainWarning = false;

  shouldExplicitlyPrependInventoryNumber = false;

  get deviceTemplateName() {
    if (this.isClientPanelAssignment) {
      const serialNo = (this.deviceProjectAssignment as ClientPanelAssignment).serialNumber;
      const categoryId = getCategoryIdFromSerialNumber(serialNo);
      const templateId = getTemplateIdFromSerialNumber(serialNo);

      return categoryId && templateId
        ? getTemplate(this.deviceSettingsJson, categoryId, templateId)?.deviceName
        : "";
    }
    else {
      const assignment = this.deviceProjectAssignment as GenericDeviceProjectAssignment;
      const categoryId = assignment.assignedDeviceCategoryId;
      const templateId = assignment.assignedDeviceTemplateId;

      if (categoryId && templateId) {
        const { updatedCategoryId, updatedTemplateId } = getUpdatedCategoryAndTemplateIds(
          categoryId,
          templateId,
          this.localDeviceSettingsJson,
          this.sharedDeviceSettingsJson
        );

        return getTemplate(
            this.deviceSettingsJson, 
            updatedCategoryId, 
            updatedTemplateId
          )?.deviceName ?? "";
      }

      return "";
    }
  }

  get showWarning() {
    return (
      this.showNoActiveProgramChainWarning ||
      this.showNoProgramChainIncludedInAssignmentWarning
    );
  }

  showProjectInfo = false;
  clientPanel: ClientPanel | null = null;

  showDependantWarning = false;

  onEditClientPanelAssignment() {
    if (!this.meetsReleaseConditions) {
      this.showDependantWarning = true;
      return;
    }

    this.$emit("editClientPanelAssignment");
  }

  get isShowingOpenEndedAssignment() {
    return !this.deviceProjectAssignment.assignmentEndDate;
  }

  get isShowingClosedAssignment() {
    return !this.isShowingOpenEndedAssignment;
  }

  get serialNumber() {
    if (
      this.clientPanel?.inventoryNumber === this.clientPanel?.serialNumber ||
      this.shouldHideSerialNumber
    ) {
      return null;
    }

    return this.clientPanel?.serialNumber;
  }

  get editDeviceAssignmentButtonText() {
    return this.isShowingOpenEndedAssignment
      ? this.$t("assignDevice.signOff")
      : this.$t("assignDevice.correct");
  }

  get runningSince() {
    if (!this.isClientPanelAssignment) {
      return "";
    }

    const clientPanelAssignment = this.deviceProjectAssignment as ClientPanelAssignment;

    if (
      areOnSameDay(
        this.projectDetails.clientData.projectStartDate,
        clientPanelAssignment.assignmentStartDate
      )
    ) {
      return "";
    }

    if (clientPanelAssignment.assignmentEndDate) {
      const assignmentStartDate = clientPanelAssignment.assignmentStartDate;
      const assignmentEndDate = clientPanelAssignment.assignmentEndDate;

      const startYear = timestampToDate(assignmentStartDate)?.getFullYear();
      const endYear = timestampToDate(assignmentEndDate)?.getFullYear();

      return this.$t("common.fromUntil", [
        formatDateShort(assignmentStartDate, undefined, undefined, startYear !== endYear),
        formatDateShort(assignmentEndDate, undefined, undefined, startYear !== endYear),
      ]);
    }

    return this.$t("common.since", [
      formatDateShort(clientPanelAssignment.assignmentStartDate),
    ]);
  }

  get selectedProgramChain() {
    if (!this.isClientPanelAssignment) {
      return undefined;
    }

    const programChain = this.programChains[0];

    if (!programChain) {
      return undefined;
    }

    return doesAssignmentIncludeProgramChain(
      this.deviceProjectAssignment as ClientPanelAssignment,
      programChain
    )
      ? programChain
      : undefined;
  }

  openPanelDetails() {
    if (!this.isClientPanelAssignment) {
      return;
    }

    const serialNumber = this.iresDevice?.serialNo;

    if (serialNumber) {
      router.push({
        path: `/main/projects/deviceDetail`,
        query: {
          projectId: this.projectDetails.id,
          serialNumber: serialNumber,
          assignmentId: this.deviceProjectAssignment.id,
          ...(this.showCompactVersion
            ? {}
            : {
                [this.usedInTab === ProjectDetailsTab.DEVICES
                  ? "startedFromDevicesTab"
                  : "startedFromConclusionTab"]: "1",
              }),
        },
      });
    }
  }

  async mounted() {
    const isDependantAssignment = this.deviceProjectAssignment.externalElectricityMeterInfo !== null;
    const shouldRetrieveIndependantClientPanel = isDependantAssignment && !this.deviceProjectAssignment.externalElectricityMeterInfo?.deviceName.includes("/");
    const independantClientPanelSerialNumber = shouldRetrieveIndependantClientPanel ? this.deviceProjectAssignment.externalElectricityMeterInfo?.deviceName : null;

    if (this.isClientPanelAssignment) {
      const serialNumber = (this.deviceProjectAssignment as ClientPanelAssignment).serialNumber;

      if (
        getIresDeviceCategoryFromSerialNumber(serialNumber) ==
        IresDeviceCategory.PANEL
      ) {
        if (this.isShowingClosedAssignment) {
          const panel = await getPanel(serialNumber, true);
          if (panel) {
            await this.onIresDeviceDetailsLoaded(panel);
          }
        } else {
          this.subscriptions.push(
            observePanel(serialNumber, async (panel) => {
              await this.onIresDeviceDetailsLoaded(panel);
            })
          );
        }
      } else {
        if (this.isShowingClosedAssignment) {
          const comBox = await getComBox(serialNumber, true);

          await this.onIresDeviceDetailsLoaded(comBox);
        } else {
          this.subscriptions.push(
            observeComBox(serialNumber, async (comBox) => {
              await this.onIresDeviceDetailsLoaded(comBox);
            })
          );
        }
      }

      this.clientPanel = await getClientPanel(serialNumber);
    }
    else if (
      shouldRetrieveIndependantClientPanel &&
      independantClientPanelSerialNumber
    ) {
      this.shouldExplicitlyPrependInventoryNumber = true;
      this.clientPanel = await getClientPanel(independantClientPanelSerialNumber);
    }
  }

  async onIresDeviceDetailsLoaded(iresDevice: IresDevice) {
    this.iresDevice = iresDevice;
    this.$emit("panelUpdate", iresDevice);

    if (!this.areDeviceDetailsLoaded) {
      await this.observeMostRecentProgramChainOfAssignment(iresDevice);
    }

    this.areDeviceDetailsLoaded = true;
  }

  async observeMostRecentProgramChainOfAssignment(iresDevice: IresDevice) {
    const clientPanelAssignment = this.deviceProjectAssignment as ClientPanelAssignment;

    const cached = ProgramChainModule.programChainOfAssignmentCache.get(
      clientPanelAssignment.id
    );

    if (cached) {
      this.programChains = [cached].filter((programChain) =>
        doesAssignmentIncludeProgramChain(
          clientPanelAssignment,
          programChain
        )
      );

      this.didLoadProgramChains = true;
    }

    const subscription = await observeProgramChainsInTimeRanges(
      clientPanelAssignment.serialNumber,
      this.projectDetails.id,
      [
        {
          id: clientPanelAssignment.id,
          startDate: clientPanelAssignment.assignmentStartDate,
          endDate: clientPanelAssignment.assignmentEndDate,
        },
      ],
      async (programChains: Array<ProgramChain>) => {
        const mostRecentProgramChain = programChains[0] ?? null;

        if (mostRecentProgramChain) {
          ProgramChainModule.cacheProgramChainOfAssignment({
            assignmentId: clientPanelAssignment.id,
            programChain: mostRecentProgramChain,
          });
        }

        if (mostRecentProgramChain != null) {
          this.programChains = [mostRecentProgramChain];
        }

        this.didLoadProgramChains = true;

        if (programChains.length === 0 && !this.isShowingClosedAssignment) {
          const mostRecentProgramChain = await getMostRecentProgramChain(
            iresDevice.serialNo
          );

          if (
            !mostRecentProgramChain ||
            !isActiveProgramChainOfIresDevice(
              iresDevice,
              mostRecentProgramChain
            )
          ) {
            this.showNoActiveProgramChainWarning = true;
          } else {
            this.showNoProgramChainIncludedInAssignmentWarning = true;
          }
        }
      }
    );

    if (subscription) {
      this.subscriptions.push(subscription);
    }
  }

  get note() {
    if (!this.deviceProjectAssignment.note || this.deviceProjectAssignment.note === "") {
      return null;
    }

    return this.$t("assignDevice.note", [this.deviceProjectAssignment.note]);
  }

  get powerConsumptionInfo() {
    const isClientPanelAssignment = this.isClientPanelAssignment;
    const clientPanelAssignment = isClientPanelAssignment
      ? this.deviceProjectAssignment as ClientPanelAssignment
      : null;
    const genericDeviceAssignment = !isClientPanelAssignment
      ? this.deviceProjectAssignment as GenericDeviceProjectAssignment
      : null;

    const meterReadingInfo = isClientPanelAssignment 
      ? clientPanelAssignment?.meterReadingInfo
      : genericDeviceAssignment
        ? extractPowerConsumptionInput(genericDeviceAssignment.input)
        : null;

    if (!meterReadingInfo) {
      if (isClientPanelAssignment) {
        const powerConsumption = clientPanelAssignment?.powerConsumptionInKWh;

        if (powerConsumption) {
          return this.$t("assignDevice.formatPowerConsumption", [
            formatKWh(this, powerConsumption, 1),
          ]).toString();
        }
      }

      return null;
    }

    const start = isClientPanelAssignment
      ? (meterReadingInfo as MeterReadingInfo).meterReadingStartKWh
      : (meterReadingInfo as GenericDevicePowerConsumptionInput).startValue ?? undefined;
    const end = isClientPanelAssignment
      ? (meterReadingInfo as MeterReadingInfo).meterReadingEndKWh
      : (meterReadingInfo as GenericDevicePowerConsumptionInput).endValue ?? undefined;

    if (start === undefined) {
      return null;
    }

    if (end === undefined || end === null) {
      return this.$t("projectDetails.meterReadingStart", [
        formatKWh(this, start, 1),
      ]).toString();
    }

    return this.$t("projectDetails.powerConsumption", [
      formatKWh(this, end - start, 1),
    ]).toString();
  }

  get assignmentTimeRangeString() {
    const startDate = this.deviceProjectAssignment.assignmentStartDate;
    const endDate = this.deviceProjectAssignment.assignmentEndDate;

    const didAssignmentStartOnProjectStart = areOnSameDay(
      startDate,
      this.projectDetails.clientData.projectStartDate
    );

    const now = firestore.Timestamp.fromDate(new Date());

    const doesAssignmentStartInFuture =
      isAfter(startDate, now) && !didAssignmentStartOnProjectStart;

    if (doesAssignmentStartInFuture) {
      return this.$t("common.startingAt", [
        formatDateShort(startDate),
      ]).toString();
    }

    if (endDate) {
      const startYear = timestampToDate(startDate)?.getFullYear();
      const endYear = timestampToDate(endDate)?.getFullYear();

      return this.$t("common.fromUntil", [
        formatDateShort(startDate, undefined, undefined, startYear !== endYear),
        formatDateShort(endDate, undefined, undefined, startYear !== endYear),
      ]).toString();
    } else {
      return this.$t("common.since", [formatDateShort(startDate)]).toString();
    }
  }

  get showDeviceStatus() {
    if (!this.areDeviceDetailsLoaded) {
      return false;
    }

    return !this.deviceProjectAssignment.assignmentEndDate;
  }

  /** The card's fill in dark mode: the palette shade of its status colour (see {@link lightCardColor}). */
  get cardColor() {
    return themedFill(this.lightCardColor);
  }

  /** Dark text on a palette fill in dark mode; the device name and number inherit it from the card. */
  get cardTextColor() {
    return themedFillTextColor(this.lightCardColor, "");
  }

  get lightCardColor() {
    if (this.showCompactVersion) {
      const clientPanelAssignment = this.isClientPanelAssignment;
      const iresDevice = this.iresDevice;

      if (!iresDevice && clientPanelAssignment) {
        return themed(COLOR_STANDARD_WHITE, COLOR_SURFACE_DARK);
      }

      if (this.deviceProjectAssignment.assignmentEndDate) {
        return COLOR_PROJECT_STEP_BUTTON_COMPLETE;
      }

      if (this.showWarning) {
        return COLOR_PROJECT_STEP_BUTTON_OVERDUE;
      }

      if (
        iresDevice &&
        clientPanelAssignment &&
        (
          isIdle(iresDevice) ||
          isPoweredOff(iresDevice) ||
          isInWarningOrError(iresDevice) ||
          isInStandBy(iresDevice)
        )
      ) {
        return COLOR_PROJECT_TILE_INCOMPLETE;
      }

      // TODO: Color
      return "#B3E0FF";
    } else {
      return themed(COLOR_STANDARD_WHITE, COLOR_SURFACE_DARK);
    }
  }

  /** Phone layout (below 600 px): the row becomes a subtitle-style list row. */
  get isPhone() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  get displayName() {
    if (!this.isClientPanelAssignment) {
      return (this.deviceProjectAssignment as GenericDeviceProjectAssignment).assignedDeviceInventoryNumber;
    }

    const assignment = this.deviceProjectAssignment as ClientPanelAssignment;
    const clientPanel = this.clientPanel;

    if (!clientPanel) {
      return getClientPanelDisplayNameFromAssignment(assignment);
    }

    return getClientPanelDisplayName(clientPanel);
  }

  get showDot() {
    if (this.deviceProjectAssignment.assignmentEndDate) {
      const selectedProgramChain = this.selectedProgramChain;

      if (selectedProgramChain) {
        return doesProgramChainIncludeActiveRun(selectedProgramChain);
      } else {
        return false;
      }
    }

    //Show dot for open assignment
    return true;
  }

  beforeDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription();
    });
  }
}
